import { FetchKitCmsContentQuery } from '../../__generated__/graphql/catalog/graphql'

import { testimonial } from './sections'

// "Kit" in Contentful
export const mockKitContent: FetchKitCmsContentQuery['kit'] = {
  id: 'mock-kit-id',
  handle: 'womens-livingston-starter-kit',
  testimonials: [testimonial, testimonial, testimonial],
  testimonialsTitle: 'Awesome Humans',
  testimonialsSubtitle: 'Ipsum elit nisi ea officia laboris id dolor ad ut adipisicing amet.',
  hideProductDetails: false,
  titleLockupImage: null,
  kitToggles: [],
  accordion: null,
  primaryImages: [],
}

export const mockKitProductGroupView: FetchKitCmsContentQuery['productGroupView'] = {
  id: 'mock-page-banner-section',
  sections: [
    {
      __typename: 'PageBannerSection',
      backgroundColorDesktop: '#f5f5f5',
      backgroundColorMobile: '#f5f5f5',

      hotspot: { linkHref1: 'https://wearfigs.com/' },
      id: '50M3-1D',
      video: {
        __typename: 'Video' as const,
        inlineVideoDesktop:
          'https://cdn.shopify.com/s/files/1/0139/8942/files/lsq3_cement_main_3600x1800_190627_al_FINAL_1.mp4?v=1561768140',
        inlineVideoMobile:
          'https://cdn.shopify.com/s/files/1/0139/8942/files/lsq2_boulder_homepage_mobile_828x1012_handbrake.mp4?v=1591307602',
        inlineVimeoIdDesktop: 586948724,
        inlineVimeoIdMobile: 586948761,
      },
      videoModal: {
        __typename: 'VideoModal' as const,
        modalVideoId: 'Jh5IHZM2yJs',
        modalVideoIdMobile: 'Jh5IHZM2yJs',
        openVideoModalText: 'WATCH THE FILM',
      },
      isFullBleedDesktop: false,
      name: 'section-name',
      overlayColorDesktop: 'rgba(255, 255, 255, 0.3)',
      overlayColorMobile: 'rgba(255, 255, 255, 0.3)',
      textPlacementDesktop: 'center',
      textPlacementMobile: 'center',
      hasVerticalMargin: true,
      styledContentItems: [],
      backgroundImage: null,
      disclaimer: undefined,
    },
  ],
  promotionalColoredTextSegments: [],
}
